import React, { useState, useEffect } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import moment from "moment";
import httpService from "../../../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../../../helpers/spinner";
import helperNumber from "../../../../../../helpers/numbers";
import helpersTime from "../../../../../../helpers/time";
import Sidebar from "../../../../../partials/aside/Sidebar";
import discountTypeAmount from "../../../../discount/campaign-banner/type-amount";
import StatusCampaignSimple from "../../../banner/StatusCampaignSimple";

function ViewCampaign() {
  const params = useParams();
  const history = useHistory();
  const campaignID = params.id;
  const [advertise, setAdvertise] = useState();
  const [campaign, setCampaign] = useState({});
  const [
    amountOneDayCampaignWithoutDiscount,
    setAmountOneDayCampaignWithoutDiscount,
  ] = useState(0);
  useEffect(() => {
    getCategoriesUserSitesPublisher();
  }, []);

  const getCategoriesUserSitesPublisher = async () => {
    let campaign = await sendRequestGetCategoriesUserSitesPublisher(campaignID);
    setCampaign(campaign);
  };

  useEffect(() => {
    if (!campaign.cam_category_id) {
      return;
    }
    setAmountOneDayCampaignWithoutDiscount(
      getAmountWithoutDiscount(
        {
          type_amount: campaign.discount_type_amount,
          amount: campaign.discount_amount,
        },
        campaign.amount / calculateDays()
      )
    );

    getAdvertise();
  }, [campaign]);

  const getAdvertise = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const advertise = await sendRequestGetAdvertise(campaignID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!advertise) {
      return;
    }
    setAdvertise(advertise);
  };

  const sendRequestGetAdvertise = async () => {
    const headersRequest = getHeaderForRequest();
    let categoryAllPublisher;
    try {
      categoryAllPublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/advertise/manage/banner/campaign/" +
          campaignID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return categoryAllPublisher.data.data;
  };

  const sendRequestGetCategoriesUserSitesPublisher = async (campaignID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const headersRequest = getHeaderForRequest();
    let categoryAllPublisher;
    try {
      categoryAllPublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/campaign/manage/banner/simple/" +
          campaignID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return categoryAllPublisher.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const calculateDays = () => {
    if (campaign === null) {
      return;
    }
    const startDate = moment(campaign.start_date);
    const endDate = moment(campaign.end_date);
    return endDate.diff(startDate, "days") + 1;
  };

  const getAmountWithoutDiscount = (discount, amount) => {
    let newAmount = 0;
    if (
      discountTypeAmount.typeAmountValue[discount.type_amount] ==
      discountTypeAmount.typeAmountString.PRICE
    ) {
      newAmount = amount + discount.amount;
    } else if (
      discountTypeAmount.typeAmountValue[discount.type_amount] ==
      discountTypeAmount.typeAmountString.PERCENT
    ) {
      newAmount = Math.floor((amount * 100) / (100 - discount.amount));
    }

    return newAmount;
  };

  const changeStateCampaign = async (campaignID, newState) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestChangeStateCampaign =
      await sendRequestChangeStateCampaign(campaignID, newState + "");
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestChangeStateCampaign) {
      return;
    }
    history.push("/campaigns/manage/banner/simple/all");
  };

  const sendRequestChangeStateCampaign = async (campaignID, newState) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/campaign/manage/banner/simple/change-state/" +
          campaignID,
        {
          new_state: newState,
        },
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const generateButtonsChangeStateCampaigns = (campaignStatus) => {
    let buttonsTags;
    switch (campaignStatus) {
      case StatusCampaignSimple.statusCampaign.PENDING_TO_START_DATE:
        buttonsTags = (
          <>
            <div>
              <span>حالت فعلی کمپین</span>
              <span className="px-2">:</span>
              <b>
                {
                  StatusCampaignSimple.statusCampaignString()[
                    campaign.cam_status
                  ]
                }
              </b>
            </div>
            <p className="py-2">
              برای تغییر حالت کمپین رو یکی از دکمه های زیر کلیک کنید
            </p>
            <span className="px-2">
              <button
                className="btn btn-success"
                onClick={(e) => {
                  e.preventDefault();
                  changeStateCampaign(
                    campaignID,
                    StatusCampaignSimple.statusCampaign.ACTIVE
                  );
                }}
              >
                {
                  StatusCampaignSimple.statusCampaignString()[
                    StatusCampaignSimple.statusCampaign.ACTIVE
                  ]
                }
              </button>
            </span>

            <span className="px-2">
              <button
                className="btn btn-danger"
                onClick={(e) => {
                  e.preventDefault();
                  changeStateCampaign(
                    campaignID,
                    StatusCampaignSimple.statusCampaign.CANCELED
                  );
                }}
              >
                {
                  StatusCampaignSimple.statusCampaignString()[
                    StatusCampaignSimple.statusCampaign.CANCELED
                  ]
                }
              </button>
            </span>
          </>
        );
        break;
      case StatusCampaignSimple.statusCampaign.ACTIVE:
        buttonsTags = (
          <>
            <div>
              <span>حالت فعلی کمپین</span>
              <span className="px-2">:</span>
              <b>
                {
                  StatusCampaignSimple.statusCampaignString()[
                    campaign.cam_status
                  ]
                }
              </b>
            </div>
            <p className="py-2">
              برای تغییر حالت کمپین رو یکی از دکمه های زیر کلیک کنید
            </p>
            <span className="px-2">
              <button
                className="btn btn-info"
                onClick={(e) => {
                  e.preventDefault();
                  changeStateCampaign(
                    campaignID,
                    StatusCampaignSimple.statusCampaign.FINISHED
                  );
                }}
              >
                {
                  StatusCampaignSimple.statusCampaignString()[
                    StatusCampaignSimple.statusCampaign.FINISHED
                  ]
                }
              </button>
            </span>

            <span className="px-2">
              <button
                className="btn btn-danger"
                onClick={(e) => {
                  e.preventDefault();
                  changeStateCampaign(
                    campaignID,
                    StatusCampaignSimple.statusCampaign.CANCELED
                  );
                }}
              >
                {
                  StatusCampaignSimple.statusCampaignString()[
                    StatusCampaignSimple.statusCampaign.CANCELED
                  ]
                }
              </button>
            </span>
          </>
        );
        break;
    }
    return buttonsTags;
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  نمایش تنظیمات کمپین بنری ساده
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="alert alert-primary ">
                <div className="col-12 col-md-6 pt-2 ">
                  <span>
                    <label className="pl-1">نام کمپین : </label>
                  </span>
                  <span>
                    <label className="pr-2">{campaign?.cam_name}</label>
                  </span>
                </div>
                <div className="col-12 col-md-6 pt-2 ">
                  <span>
                    <label className="pl-1">شماره کمپین : </label>
                  </span>
                  <span>
                    <label className="pr-2">{campaign?.cam_id}</label>
                  </span>
                </div>
                <div className=" pt-2 d-flex align-items-center ">
                  <span>
                    <b>شماره کاربری</b>:
                  </span>
                  <span>
                    <span className="px-2">
                      {helperNumber.toPersianNum(campaign?.cam_user_id)}
                    </span>
                    <Link
                      target="_blank"
                      to={`/user/show-info-user/${campaign?.cam_user_id}`}
                    >
                      <span className="btn btn-primary">
                        نمایش اطلاعات کاربر
                      </span>
                    </Link>
                  </span>
                </div>
                <div className=" pt-2 d-flex align-items-center ">
                  <span>
                    <b>شماره گروه نمایش دهنده بنری :</b>
                  </span>
                  <span>
                    <span className="px-2">
                      {helperNumber.toPersianNum(campaign?.cam_category_id)}
                    </span>
                    <Link
                      target="_blank"
                      to={`/manage/category-user-site-publishers/${campaign?.cam_category_id}`}
                    >
                      <span className="btn btn-primary">
                        نمایش گروه نمایش دهنده بنری
                      </span>
                    </Link>
                  </span>
                </div>
                {advertise && (
                  <div className=" pt-2 d-flex align-items-center ">
                    <span>
                      <b>شماره تبلیغ:</b>
                    </span>
                    <span>
                      <span className="px-2">
                        {helperNumber.toPersianNum(advertise.adv_id)}
                      </span>
                      <Link
                        target="_blank"
                        to={`/advertise/manage/banner/edit/${advertise.adv_id}`}
                      >
                        <span className="btn btn-primary">نمایش تبلیغ</span>
                      </Link>
                    </span>
                  </div>
                )}

                <div className="col-12 col-md-6 pt-2 ">
                  <span>
                    <label className="pl-1">تاریخ شروع : </label>
                  </span>
                  <span className="number-finance">
                    <label className="pr-2" dir="ltr">
                      {campaign?.start_date !== undefined
                        ? helperNumber.toPersianNum(
                            helpersTime.convertGregorianToJalali(
                              campaign?.start_date
                            ) + " 00:00"
                          )
                        : ""}
                    </label>
                  </span>
                </div>
                <div className="col-12 col-md-6 pt-2 ">
                  <span>
                    <label className="pl-1">تاریخ پایان : </label>
                  </span>
                  <span className="number-finance">
                    <label className="pr-2" dir="ltr">
                      {campaign?.start_date !== undefined
                        ? helperNumber.toPersianNum(
                            helpersTime.convertGregorianToJalali(
                              campaign?.end_date
                            ) + " 23:59"
                          )
                        : ""}
                    </label>
                  </span>
                </div>

                {campaign?.cam_discount_id != 0 ? (
                  <div className="col-12 col-md-6 pt-2 text-danger">
                    <span>
                      <label className="pl-1">کد تخفیف استفاده شده : </label>
                    </span>

                    <span className="pl-2 ">
                      <label>{campaign?.discount_title}</label>
                      <label className="px-3 letter-spacing-finance-number">
                        {helperNumber.toPersianNum(
                          helperNumber.toFormatFinanceNumber(
                            campaign?.discount_amount
                          )
                        )}
                      </label>
                      <label>
                        {
                          discountTypeAmount.typeAmountStringPersian[
                            discountTypeAmount.typeAmountValue[
                              campaign?.discount_type_amount
                            ]
                          ]
                        }
                      </label>
                    </span>
                  </div>
                ) : (
                  <></>
                )}

                <div className="col-12 col-md-6 pt-2 ">
                  <span>
                    <label className="pl-1">مبلغ یک شبانه روز کمپین : </label>
                  </span>

                  {campaign?.cam_discount_id != 0 ? (
                    <span>
                      <label className="letter-spacing-finance-number  text-decoration-line-through">
                        {helperNumber.toPersianNum(
                          helperNumber.toFormatFinanceNumber(
                            amountOneDayCampaignWithoutDiscount
                          )
                        )}
                      </label>
                      <label className="px-2  text-decoration-line-through">
                        تومان
                      </label>
                    </span>
                  ) : (
                    <></>
                  )}

                  <span>
                    <label
                      className={` letter-spacing-finance-number 
                    ${
                      amountOneDayCampaignWithoutDiscount ? "text-danger" : ""
                    }    `}
                    >
                      {helperNumber.toPersianNum(
                        helperNumber.toFormatFinanceNumber(
                          Math.floor(campaign.amount / calculateDays())
                        )
                      )}
                    </label>
                    <label
                      className={`pr-2     ${
                        amountOneDayCampaignWithoutDiscount ? "text-danger" : ""
                      } `}
                    >
                      تومان
                    </label>
                  </span>
                </div>
                <div className="col-12 col-md-6 pt-2 ">
                  <span>
                    <label className="pl-1">
                      مبلغی که در هر ساعت کسر میشود :
                    </label>
                  </span>
                  {campaign?.cam_discount_id != 0 ? (
                    <span>
                      <label className="letter-spacing-finance-number  text-decoration-line-through">
                        {helperNumber.toPersianNum(
                          helperNumber.toFormatFinanceNumber(
                            Math.floor(amountOneDayCampaignWithoutDiscount / 24)
                          )
                        )}
                      </label>
                      <label className="px-2  text-decoration-line-through">
                        تومان
                      </label>
                    </span>
                  ) : (
                    <></>
                  )}
                  <span>
                    <label
                      className={` letter-spacing-finance-number 
    ${amountOneDayCampaignWithoutDiscount ? "text-danger" : ""}    `}
                    >
                      {helperNumber.toPersianNum(
                        helperNumber.toFormatFinanceNumber(
                          Math.floor(
                            Math.floor(campaign?.amount / calculateDays()) / 24
                          )
                        )
                      )}
                    </label>
                    <label
                      className={`pr-2     ${
                        amountOneDayCampaignWithoutDiscount ? "text-danger" : ""
                      } `}
                    >
                      تومان
                    </label>
                  </span>
                </div>
                <div className="col-12 col-md-6 pt-2 ">
                  <span>
                    <label className="pl-1">تعداد شبانه روز کمپین : </label>
                  </span>
                  <span>
                    <label>{helperNumber.toPersianNum(calculateDays())}</label>
                    <label className="pr-2">شبانه روز</label>
                  </span>
                </div>
                <div className="col-12 col-md-6 pt-2 ">
                  <span>
                    <label className="pl-1">مبلغ کمپین :</label>
                  </span>
                  {campaign?.cam_discount_id != 0 ? (
                    <span>
                      <label className="letter-spacing-finance-number  text-decoration-line-through">
                        {helperNumber.toPersianNum(
                          helperNumber.toFormatFinanceNumber(
                            Math.floor(
                              amountOneDayCampaignWithoutDiscount *
                                calculateDays()
                            )
                          )
                        )}
                      </label>
                      <label className="px-2  text-decoration-line-through">
                        تومان
                      </label>
                    </span>
                  ) : (
                    <></>
                  )}
                  <span>
                    <label
                      className={` letter-spacing-finance-number 
    ${amountOneDayCampaignWithoutDiscount ? "text-danger" : ""}    `}
                    >
                      {helperNumber.toPersianNum(
                        helperNumber.toFormatFinanceNumber(campaign?.amount)
                      )}
                    </label>
                    <label
                      className={`pr-2     ${
                        amountOneDayCampaignWithoutDiscount ? "text-danger" : ""
                      } `}
                    >
                      تومان
                    </label>
                  </span>
                </div>
                <div className="col-12 col-md-6 pt-2 ">
                  <span>
                    <label className="pl-1">مبلغ بیعانه کمپین :</label>
                  </span>

                  {campaign?.cam_discount_id != 0 ? (
                    <span>
                      <label className="letter-spacing-finance-number  text-decoration-line-through">
                        {helperNumber.toPersianNum(
                          helperNumber.toFormatFinanceNumber(
                            Math.floor(
                              (amountOneDayCampaignWithoutDiscount *
                                calculateDays()) /
                                process.env.REACT_APP_DEPOSIT_COEFFICIENT
                            )
                          )
                        )}
                      </label>
                      <label className="px-2  text-decoration-line-through">
                        تومان
                      </label>
                    </span>
                  ) : (
                    <></>
                  )}
                  <span>
                    <label
                      className={` letter-spacing-finance-number 
    ${amountOneDayCampaignWithoutDiscount ? "text-danger" : ""}    `}
                    >
                      {helperNumber.toPersianNum(
                        helperNumber.toFormatFinanceNumber(
                          campaign?.pledge_amount
                        )
                      )}
                    </label>
                    <label
                      className={`pr-2     ${
                        amountOneDayCampaignWithoutDiscount ? "text-danger" : ""
                      } `}
                    >
                      تومان
                    </label>
                  </span>
                </div>
                <div className="col-12 col-md-6 pt-2 ">
                  <span>
                    <label className="pl-1">مبلغ کل کمپین :</label>
                  </span>

                  {campaign?.cam_discount_id != 0 ? (
                    <span>
                      <label className="letter-spacing-finance-number  text-decoration-line-through">
                        {helperNumber.toPersianNum(
                          helperNumber.toFormatFinanceNumber(
                            amountOneDayCampaignWithoutDiscount *
                              calculateDays() +
                              Math.floor(
                                (amountOneDayCampaignWithoutDiscount *
                                  calculateDays()) /
                                  process.env.REACT_APP_DEPOSIT_COEFFICIENT
                              )
                          )
                        )}
                      </label>
                      <label className="px-2  text-decoration-line-through">
                        تومان
                      </label>
                    </span>
                  ) : (
                    <></>
                  )}
                  <span>
                    <label
                      className={` letter-spacing-finance-number 
    ${amountOneDayCampaignWithoutDiscount ? "text-danger" : ""}    `}
                    >
                      {helperNumber.toPersianNum(
                        helperNumber.toFormatFinanceNumber(
                          campaign?.total_amount
                        )
                      )}
                    </label>
                    <label
                      className={`pr-2     ${
                        amountOneDayCampaignWithoutDiscount ? "text-danger" : ""
                      } `}
                    >
                      تومان
                    </label>
                  </span>
                </div>
              </div>
              <hr />
              <div className="alert alert-warning">
                <p>قبل از تغییر حالت کمپین به حالت فعلی کمپین توجه کنید.</p>
                <p className="text-danger">
                  نکته خیلی مهم : حتما بعد از تغییر حالت کمپین به حالت مورد نظر
                  به{" "}
                  <Link
                    className="px-2 d-inline-block"
                    target={"_blank"}
                    to="/manage/publishers/check-position-campaign"
                  >
                    صفحه
                  </Link>
                  بروید و شماره کمپین را وارد کنید و جایگاه های کمپین را بروز
                  رسانی کنید
                </p>
                <p>
                  تغییر حالت کمپین از حالت لغو شده و تمام شده به حالت های دیگر
                  به خاطر زمان رزور شدن جایگاه توسط کاربران دیگر امکانپذیر نیست.
                </p>
                <p>
                  تغییر حالت کمپین از هر حالتی به حالت در حال انتظار به خاطر
                  زمان رزور شدن جایگاه توسط کاربران دیگر امکانپذیر نیست.
                </p>
              </div>
              <div>
                {generateButtonsChangeStateCampaigns(campaign.cam_status)}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default ViewCampaign;
